import { useTranslation } from 'react-i18next'
import { ListWorkRules } from '~/features/common/WorkRule/ListWorkRules'
import { PageContainer, Container } from '~/shared/ui/Layout'

function ListWorkRulesPage() {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('working conditions')}>
      <Container>
        <ListWorkRules />
      </Container>
    </PageContainer>
  )
}

export default ListWorkRulesPage
